export enum HEADER_TYPE_ENUM {
  text = 'TEXT',
  media = 'MEDIA',
  image = 'IMAGE',
  video = 'VIDEO',
  document = 'DOCUMENT'
}
